import React, { useState } from 'react';
import Modal from './Modal';

export default function FeedbackForm({ user, onClose }) {
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    try {
      // Send feedback to your API here
      await fetch('/api/feedback', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: user?.username || "",
          email: user?.email || "",
          message
        })
      });
      setSent(true);
      setTimeout(onClose, 1200); // Auto-close after sent
    } catch {
      alert("Failed to send feedback.");
    }
    setSubmitting(false);
  };

  return (
    <Modal open={true} onClose={onClose} width={430}>
      <h2 style={{marginTop: 0}}>Send Feedback</h2>
      <form onSubmit={handleSubmit} style={{display: "flex", flexDirection: "column", gap: 12}}>
        <div>
          <label>Name</label>
          <input type="text" value={user?.username || ""} disabled style={{width: "100%"}} />
        </div>
        <div>
          <label>Email</label>
          <input type="email" value={user?.email || ""} disabled style={{width: "100%"}} />
        </div>
        <div>
          <label>Message</label>
          <textarea
            required
            value={message}
            onChange={e => setMessage(e.target.value)}
            rows={5}
            style={{width: "100%"}}
          />
        </div>
        <div style={{display: "flex", gap: 12, marginTop: 12}}>
          <button type="submit" disabled={submitting || sent} style={{fontWeight: 700, background: "#41dca5", border: "none", padding: "8px 22px", borderRadius: 5, cursor: "pointer"}}>{sent ? "Sent!" : "Send"}</button>
          <button type="button" onClick={onClose} disabled={submitting} style={{background: "#333", border: "none", padding: "8px 22px", borderRadius: 5, color: "#fff", cursor: "pointer"}}>Cancel</button>
        </div>
      </form>
    </Modal>
  );
}
